// API fetch
import axios from "axios";
import { baseURL,cloudRunBaseURL } from '../config/api-config.js';

export async function getArticles(){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/article`,
    });
    const articles = response.data;
    return articles;

  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function getAccessoires(){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/article/access/all`,
    });
    const accessoires = response.data;
    return accessoires;

  } catch (err) {
    console.error(err);
    return null;
  }
}


export async function getOneSpot(id){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/spot/${id}`,
    });
    const spot = response.data.data;
    return spot;

  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function getStockPeriode(date1,date2){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/stock-periode/${date1}/${date2}`,
    });
    const allArticles = response.data;
    return allArticles;

  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function getAllTarifs(){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/tarif`,
    });
    const allTarifs = response.data;
    return allTarifs;

  } catch (err) {
    console.error(err);
    return null;
  }
}

export async function getPaiement(ref){

  try {
    const response = await axios({
      method: 'GET',
      url: cloudRunBaseURL + `paiement/${ref}`,
    });
    const paiement = response.data.data;
    return paiement;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getContrat(ref){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/ref/${ref}`,
    });
    const contrat = response.data;
    return contrat;

  } catch (err) {
    console.error(err);
    return [];
  }
}

//meme que dessus mais conflit de nom avec redux
export async function getContratByRef(ref){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/ref/${ref}`,
    });
    const contrat = response.data[0];
    return contrat;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getAllContrats(){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat`,
    });
    const contrat = response.data;
    return contrat;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getAllContratsSearch(keyword){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/search/${keyword}`,
    });
    const contrat = response.data;
    return contrat;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getAllContratsPeriod(date1,date2){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/period/${date1}/${date2}`,
    });
    const contrats = response.data;
    return contrats;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getAllContratsWeek(date1,date2){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/week/${date1}/${date2}`,
    });
    const contrats = response.data;
    return contrats;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getAllContratsDay(date){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/day/${date}`,
    });
    const contrats = response.data;
    return contrats;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getUnpaidContrats(){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/contrat/unpaid/list`,
    });
    const contrat = response.data;
    return contrat;

  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function updateContratAccess(id,body){

  try {
    const response = await axios({
      method: 'PUT',
      data:body,
      url: baseURL + `/contrat-access/${id}`,
    });
    const contrat = response.data;
    return response;

  } catch (err) {
    console.error(err);
    return [];
  }
}


export async function getCaisse(){

  try {
    const response = await axios({
      method: 'GET',
      url: baseURL + `/caisse`,
    });
    const contrat = response.data;
    return contrat;

  } catch (err) {
    console.error(err);
    return [];
  }
}